import { CognitoUser } from 'amazon-cognito-identity-js';
import { AuthStage } from '.';
interface Params {
  user: CognitoUser;
  setAuthStage: (stage: AuthStage) => void;
}

export default function onForgotPassword(params: Params) {
  const { user, setAuthStage } = params;
  const onSuccess = () => {
    setAuthStage(AuthStage.FORGOT_SENT);
  };
  const onFailure = () => {
    setAuthStage(AuthStage.FORGOT_SENT);
  };

  user!.forgotPassword({ onSuccess, onFailure });
  setAuthStage(AuthStage.FORGOT_SENT);
}
